<template>
  <div>
    <v-card
      :style="$vuetify.breakpoint.mdAndUp ? '' : 'background-color: #eee;'"
      :class="$vuetify.breakpoint.mdAndUp ? 'pa-4 rounded-lg' : ''"
      :outlined="$vuetify.breakpoint.mdAndUp"
      elevation="0"
    >
      <v-row v-if="!$route.query.sectorMode" no-gutters>
        <v-col>
          <span class="checkout-h6 accent--text" style="font-weight: 700"
            >{{ eventDetails.nome }}
          </span>
          <v-row class="mt-4" no-gutters align="center">
            <span>
              <v-icon small color="accent" class="mr-2"
                >mdi-calendar-check-outline</v-icon
              >
              <span class="checkout-h4 accent--text">{{
                eventDetails.data_exibicao
              }}</span>
            </span>
          </v-row>
          <v-row v-if="eventDetails.horario_exibicao" no-gutters align="center">
            <span>
              <v-icon small color="accent" class="mr-2"
                >mdi-clock-time-three-outline</v-icon
              >
              <span class="checkout-h4 accent--text">{{
                eventDetails.horario_exibicao
              }}</span>
            </span>
          </v-row>
          <v-row no-gutters align="center">
            <span>
              <v-icon small color="accent" class="mr-2"
                >mdi-map-marker-outline</v-icon
              >
              <span class="checkout-h4 accent--text">{{
                eventDetails.local
                  ? eventDetails.local.nome
                  : $t("general.locationToBeDefined")
              }}</span>
            </span>
          </v-row>
        </v-col>
        <v-card class="rounded-lg" elevation="0" width="110" height="64">
          <v-img contain :src="imgUrl" alt="Evento" />
        </v-card>
      </v-row>
      <v-row
        v-if="
          cartProducts &&
          cartProducts.length &&
          !$route.query.sectorMode &&
          ($vuetify.breakpoint.mdAndUp ||
            ($route.name !== 'Cart' && $route.name && step !== 'Cart'))
        "
        class="py-3"
        no-gutters
      >
        <v-divider></v-divider>
      </v-row>
      <v-row
        v-if="
          cartProducts &&
          cartProducts.length &&
          ($vuetify.breakpoint.mdAndUp ||
            ($route.name !== 'Cart' && $route.name && step !== 'Cart'))
        "
        no-gutters
        align="center"
      >
        <span class="checkout-h7 accent--text" style="letter-spacing: 1.5px">{{
          $t("cart.tickets").toUpperCase()
        }}</span>
        <v-spacer></v-spacer>
        <v-btn
          v-if="
            ($route.name === 'Payment' ||
              $route.name === 'Participants' ||
              step === 'Payment' ||
              step === 'Participants') &&
            !$route.query.order_hash &&
            !showPixScreen &&
            !showSecurityCheck
          "
          rounded
          small
          depressed
          color="primary"
          @click="goTickets"
          >{{ $t("summary.edit") }}</v-btn
        >
      </v-row>
      <div
        v-if="
          cartProducts &&
          cartProducts.length &&
          ($vuetify.breakpoint.mdAndUp ||
            ($route.name !== 'Cart' && $route.name && step !== 'Cart'))
        "
        class="pt-4"
      >
        <div v-if="!$route.query.order_hash">
          <div v-for="(product, index) in cartProducts" :key="index">
            <v-row
              v-for="(type, i) in product"
              :key="i"
              no-gutters
              align="center"
            >
              <v-col cols="8">
                <span class="checkout-h3 accent-text" style="font-weight: 400">
                  {{ type.quantidade }}x {{ type.nome }} - {{ type.nome_tipo }}
                  {{ type?.objsSeats ? verifySeats(type?.objsSeats) : "" }}
                </span>
              </v-col>

              <v-col align="end">
                <span class="checkout-h3 accent--text" style="font-weight: 400">
                  {{
                    (type.quantidade *
                      (storeDetails?.id === 4
                        ? type.valor
                        : type.valor + type.valor_conveniencia))
                      | currency
                  }}
                </span>
              </v-col>
            </v-row>
          </div>
        </div>

        <div v-if="$route.query.order_hash">
          <v-row v-for="(product, c) in orderProducts" :key="c">
            <v-col cols="8">
              <span class="checkout-h3 accent-text" style="font-weight: 400">
                {{ product.quantidade }}x {{ product.nome }} -
                {{ product.nome_tipo }}
                {{ product?.objsSeats ? verifySeats(product?.objsSeats) : "" }}
              </span>
            </v-col>

            <v-col align="end">
              <span class="checkout-h3 accent--text" style="font-weight: 400">
                {{
                  (product.quantidade *
                    (storeDetails?.id === 4
                      ? product.valor
                      : product.valor + product.valor_conveniencia))
                    | currency
                }}
              </span>
            </v-col>
          </v-row>
        </div>
      </div>

      <v-row
        v-if="cartProducts && cartProducts.length > 0 && storeDetails?.id === 4"
        no-gutters
        class="pt-3"
      >
        <strong class="checkout-h3 accent--text" style="font-weight: bold">
          {{ $t("summary.ticketsTotal") }}
        </strong>
        <v-spacer></v-spacer>
        <span class="checkout-h3 accent--text" style="font-weight: bold">{{
          productsTotalWithoutTax | currency
        }}</span>
      </v-row>

      <v-row
        v-if="cartProducts && cartProducts.length > 0 && storeDetails?.id === 4"
        no-gutters
        class="pt-3"
      >
        <strong class="checkout-h3 accent--text" style="font-weight: bold">
          {{ $t("summary.serviceTax") }}
        </strong>
        <v-spacer></v-spacer>
        <span class="checkout-h3 accent--text" style="font-weight: bold">{{
          taxTotal | currency
        }}</span>
      </v-row>

      <v-row
        v-if="$route.name !== 'Cart' && $route.name && step !== 'Cart'"
        class="pt-4"
        no-gutters
      >
        <v-divider></v-divider>
      </v-row>
      <div v-if="paymentOption === 'CC'">
        <v-row class="py-4" no-gutters>
          <span class="checkout-h3 accent--text">{{
            $t("payment.howWantPay")
          }}</span>
        </v-row>
        <v-divider></v-divider>
        <v-row class="py-4" no-gutters>
          <span class="checkout-h3 accent--text">{{
            $t("general.installments")
          }}</span>
          <v-spacer></v-spacer>
          <span
            v-if="buyer && buyer.installment_amount"
            class="checkout-h3 accent--text"
            style="font-weight: bold"
            >{{ buyer.installment_amount.instalments }}x
            {{ buyer.installment_amount.interestAmount | currency }}</span
          >
          <span
            v-else
            class="checkout-h3 accent--text"
            style="font-weight: bold"
            >1x {{ productsTotal | currency }}</span
          >
        </v-row>
        <v-divider></v-divider>

        <v-row
          v-if="paymentDetails?.transaction_charge_credit"
          class="py-4"
          no-gutters
        >
          <span class="checkout-h3 accent--text">{{
            $t("general.processingFee")
          }}</span>
          <v-tooltip color="accent" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                size="20"
                class="ml-1"
                color="accent"
                @click.stop="() => {}"
                style="cursor: default !important"
                v-bind="attrs"
                v-on.stop="on"
                >mdi-information</v-icon
              >
            </template>
            <v-row style="width: 200px !important" no-gutters>
              <span>{{ $t("general.processingFeeDescription") }}</span>
            </v-row>
          </v-tooltip>
          <v-spacer></v-spacer>
          <span class="checkout-h3 accent--text" style="font-weight: bold">{{
            paymentDetails?.transaction_charge_credit | currency
          }}</span>
        </v-row>
        <v-divider></v-divider>
      </div>

      <v-row
        v-if="
          cartProducts &&
          cartProducts.length &&
          ($vuetify.breakpoint.mdAndUp ||
            ($route.name && $route.name !== 'Cart' && step !== 'Cart'))
        "
        :class="storeDetails?.id === 4 ? 'pt-3' : 'pt-4'"
        no-gutters
      >
        <strong class="checkout-h3 accent--text" style="font-weight: bold">
          Total
        </strong>
        <v-spacer></v-spacer>
        <span
          v-if="buyer && buyer.installment_amount && paymentOption === 'CC'"
          class="checkout-h3 accent--text"
          style="font-weight: bold"
          >{{ buyer.installment_amount.total | currency }}</span
        >
        <span
          v-else-if="!$route.query.order_hash"
          class="checkout-h3 accent--text"
          style="font-weight: bold"
          >{{ productsTotal | currency }}</span
        >
        <span
          v-else
          class="checkout-h3 accent--text"
          style="font-weight: bold"
          >{{ orderAmount | currency }}</span
        >
      </v-row>
      <v-row
        class="py-3"
        v-if="$route.query.order_hash && orderDetails"
        no-gutters
      >
        <span class="checkout-h3 accent--text" style="font-weight: bold">
          {{ $t("summary.amountPaid") }}
        </span>
        <v-spacer></v-spacer>
        <strong class="checkout-h3 accent--text" style="font-weight: bold">{{
          orderDetails.valor_pago | currency
        }}</strong>
      </v-row>
      <v-row
        class="py-3"
        v-if="$route.query.order_hash && orderDetails"
        no-gutters
      >
        <span class="checkout-h3 accent--text" style="font-weight: bold">
          {{ $t("summary.balanceToPay") }}
        </span>
        <v-spacer></v-spacer>
        <strong class="checkout-h3 accent--text" style="font-weight: bold">{{
          orderDetails.valor_pendente | currency
        }}</strong>
      </v-row>
      <v-row
        v-if="
          cartProducts &&
          cartProducts.length &&
          $vuetify.breakpoint.mdAndUp &&
          !$route.query.embed &&
          ($route.name === 'Cart' || (!$route.name && step === 'Cart'))
        "
        class="mt-4"
        no-gutters
      >
        <v-btn
          width="100%"
          rounded
          depressed
          color="primary"
          :loading="loading"
          height="40"
          @click="$emit('createOrder')"
          >{{ $t("cart.continue") }}</v-btn
        >
      </v-row>
      <v-row
        v-if="
          ($route.name === 'Payment' || step === 'Payment') &&
          !showPixScreen &&
          !showSecurityCheck &&
          $vuetify.breakpoint.mdAndUp
        "
        class="mt-4"
        no-gutters
      >
        <v-btn
          width="100%"
          rounded
          depressed
          color="primary"
          :disabled="
            productsTotal ? !canPurchase || !paymentOption : !canPurchase
          "
          :loading="loading"
          height="40"
          @click="$emit('purchase')"
          >{{
            paymentOption === "PIX"
              ? $t("cart.continue")
              : $t("summary.confirm")
          }}
        </v-btn>
      </v-row>
      <v-row
        v-if="
          cartProducts &&
          cartProducts.length &&
          ($vuetify.breakpoint.mdAndUp ||
            ($route.name && $route.name !== 'Cart' && step !== 'Cart')) &&
          showDateCancel
        "
        class="mt-4"
        justify="center"
        no-gutters
      >
        <span
          class="checkout-h8"
          style="color: rgb(23, 169, 108); font-weight: 600; font-size: 14px"
        >
          {{ $t("payment.cancelFree") }} {{ dateCancellation }}
        </span>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["loading", "showPixScreen"],
  computed: {
    ...mapGetters([
      "cartProducts",
      "buyer",
      "productsTotal",
      "paymentOption",
      "orderDetails",
      "eventDetails",
      "canPurchase",
      "productsDetails",
      "orderDetails",
      "selectedSector",
      "noSectorList",
      "showSecurityCheck",
      "storeDetails",
      "orderProducts",
      "orderAmount",
      "eventId",
      "step",
      "paymentDetails",
    ]),
    imgUrl() {
      if (
        this.eventDetails.midias.find(
          (midia) => midia.codigo_midia === 1 && midia.ativo === 1
        )
      )
        return this.eventDetails.midias.find(
          (midia) => midia.codigo_midia === 1 && midia.ativo === 1
        ).url;
      else return "";
    },
    showDateCancel() {
      return (
        this.$moment().isBefore(
          this.eventDetails?.politicas_cancelamento.etapas[0]
            ?.prazo_cancelamento
        ) && this.eventDetails?.politicas_cancelamento?.permite_cancelamento
      );
    },
    dateCancellation() {
      return this.eventDetails?.politicas_cancelamento.etapas[0]
        ? this.$moment(
            this.eventDetails.politicas_cancelamento.etapas[0]
              .prazo_cancelamento
          ).format("DD/MM/YYYY")
        : null;
    },
    productsTotalWithoutTax() {
      let total = 0;
      let somador = 0;

      this.cartProducts.forEach((p) => {
        p.forEach((v) => {
          somador += v.valor * v.quantidade;
        });
      });

      total = somador;

      return total;
    },
    taxTotal() {
      let total = 0;
      let somador = 0;

      this.cartProducts.forEach((p) => {
        p.forEach((v) => {
          somador += v.valor_conveniencia * v.quantidade;
        });
      });

      total = somador;

      return total;
    },
  },
  methods: {
    verifySeats(value) {
      if (!value) return "";
      var sumSeats = "";
      value.forEach((el) => {
        if (sumSeats)
          sumSeats = sumSeats + `, ${this.getIdentification(el.identificacao)}`;
        else sumSeats = sumSeats + this.getIdentification(el.identificacao);
      });

      return `(${sumSeats})`;
    },
    getIdentification(el) {
      let formatted = el.replace("Mesa", "");
      let getRow = el.toString().split(";").shift();
      let getNumber = el.toString().split(";").pop();
      if (el.includes("Mesa")) {
        if (el.includes(";"))
          return (
            "Mesa " +
            formatted.split(";")[0] +
            " Cadeira " +
            formatted.split(";").pop()
          );
        else return "Mesa " + formatted;
      } else if (el.includes("MESA")) {
        return "Mesa " + formatted.split("-")[1];
      }

      return getRow + `-${getNumber}`;
    },
    goTickets() {
      let obj = {
        whereICame: this.$route.name,
        order: this.orderDetails,
        productsDetails: this.productsDetails,
        cart: this.noSectorList,
        selectedSector: this.selectedSector,
        route: "Cart",
      };
      localStorage.setItem(
        `cart-order-route-${this.eventId}`,
        JSON.stringify(obj)
      );
      this.$router.push({
        name: "Cart",
        params: { event: this.eventId },
        query: this.$route.query,
      });
    },
  },
};
</script>
